import React, { Component } from "react";
import ViewMarketingAgent from "./ViewMarketingAgent";
import CreateMarketingAgent from "./CreateMarketingAgent";
import setTitle from "../../../helpers/TitleComponent";
import { getCookie } from "../../../helpers/cookieHelper";

export default class MarketingAgent extends Component {
  constructor() {
    super();
    this.handleChange = this.handleChange.bind(this);
    this.OnEditClick = this.OnEditClick.bind(this);
    this.onSelectionChange = this.onSelectionChange.bind(this);
    this.formClear = this.formClear.bind(this);
    this.childRef = React.createRef();
    this.state = {
      form: {
        agentType: "organization",
        agentName: "",
        address: "",
        panNo: "",
        marketingArea: "",
        profitSharingTerms: "",
        rolesAndResponsibilites: "",
        contactNo: "",
        altContactNo: "",
        officeContact: "",
        contactPersonName: "",
        enabled: true,
      },
      isPersonel: false,
      enabled: [
        { value: true, text: "Active" },
        { value: false, text: "Inactive" },
      ],
      rules: {
        agentType: ["required"],
        agentName: ["required"],
        address: ["required"],
        marketingArea: ["required"],
        profitSharingTerms: ["required"],
        rolesAndResponsibilites: ["required"],
        contactNo: ["required"],
        // officeContact: ["required"],
        // contactPersonName: ["required"],
      },
      operation: "Add",
      selected: {},
      permissions: [],
    };
  }

  componentDidMount() {
    var data = getCookie("permission");


    this.setState(
      {
        permissions: JSON.parse(data),
      },
      function () {
        setTitle("Marketing Agent");
      }
    );

  }

  OnEditClick() {
    var { selected } = this.state;
    let { rules } = this.state



    if (selected != null) {
      selected["rolesAndResponsibilites"] =
        selected["rolesAndResponsibilities"];



      this.setState(
        {
          form: selected,

        },
        function () {
          this.childRef.current.validate((errors) => { });
        }
      );
    }
  }

  onSelectionChange(selectedRow) {

    this.setState({
      selected: selectedRow,
      operation: "Update",
    });
  }

  formClear() {
    var form = {
      agentType: "organization",
      agentName: "",
      address: "",
      panNo: "",
      marketingArea: "",
      profitSharingTerms: "",
      rolesAndResponsibilites: "",
      contactNo: "",
      altContactNo: "",
      officeContact: "",
      contactPersonName: "",
      enabled: true,
    };
    this.setState(
      {
        form,
      },
      function () {
        this.childRef.current.validate((errors) => { });
      }
    );
  }

  handleChange(name, value) {
    let form = Object.assign({}, this.state.form);
    let rules = this.state.rules



    // if(form[name] === 'individual'){

    //    delete form['officeContact']
    //   delete form['contactPersonName']

    //   } 
    // form[name] = value
    // if (form[name] === 'individual') {
    //   this.setState({isPersonel: true})
    //   // delete form['officeContact']
    //   // delete form['contactPersonName']
    // } 
    // // else if(form[name] === 'organization') {
    //   this.setState({isPersonel: false})
    // //   form['officeContact']
    // //   form['contactPersonName']
    // // }
    form[name] = value
    this.setState({ form });

  }

  render() {
    var permissions = this.state.permissions;
    var { isPersonel } = this.state
    return (
      <div className="container-fluid">
        <div className="row">
          {permissions.includes("user-registration-create") ? (
            <div className="col-5 ">
              <CreateMarketingAgent
                form={this.state.form}
                isPersonel={isPersonel}
                validationRules={this.state.rules}
                handleChange={this.handleChange}
                operation={this.state.operation}
                ref={this.childRef}
                formClear={this.formClear}
                enabled={this.state.enabled}
              />
            </div>
          ) : (
            ""
          )}
          {permissions.includes("user-registration-view") ? (
            <div className="col-7 ">
              <ViewMarketingAgent
                selectedRow={this.state.selected}
                OnEditClick={this.OnEditClick}
                onSelectionChange={this.onSelectionChange}
                permissions={permissions}
                enabled={this.state.enabled}
              />
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }
}
